import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystarentalinpune() {



  const cardData =
  {
    keyword: 'Innova Crysta Rental in Pune',
    heading: 'Aaryan Travels: Innova Crysta Rental in Pune',
    headingDescription: ' Aaryan Travels offers premium Innova Crysta Rental in Pune for family tours, corporate travel, airport transfers, and long-distance journeys. Known for its spacious interiors, superior comfort, and powerful performance, the Innova Crysta is the preferred choice for group travel across Maharashtra and beyond. Whether you are planning a trip to Mahabaleshwar, Shirdi, Goa, or simply need a comfortable cab for city rides, our well-maintained Crysta fleet ensures a luxurious and safe travel experience. With experienced chauffeurs, dual AC, ample luggage space, and 24/7 availability, Aaryan Travels delivers the most reliable and affordable Innova Crysta on rent in Pune for one-way or round-trip bookings.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


"services": [
  {
    "name": "Innova Crysta Rental in Pune",
    "description": "Experience the comfort and reliability of Innova Crysta Rental in Pune, perfect for family trips, corporate travel, and group outings. Our fleet consists of well-maintained Innova Crysta vehicles, ensuring a smooth ride with spacious interiors and advanced safety features. Whether it’s for a short city trip or long-distance travel, our rental service offers flexible packages and competitive pricing to suit your needs."
  },
  {
    "name": "Hire Innova Crysta Pune",
    "description": "Hire an Innova Crysta in Pune with ease through our convenient booking process. Our vehicles are equipped with air conditioning, plush seating, and ample luggage space, making them ideal for comfortable travel. With professional drivers available or self-drive options, you can customize your experience based on your preferences and schedule."
  },
  {
    "name": "Pune SUV Rental",
    "description": "Our Pune SUV Rental service features the Innova Crysta among other premium SUVs, providing robust performance and luxury for city and outstation travel. Suitable for families, corporate clients, and group travelers, our SUVs come with trained drivers and comprehensive insurance coverage, ensuring a safe and hassle-free journey."
  },
  {
    "name": "Chauffeur Driven Innova Pune",
    "description": "Opt for our Chauffeur Driven Innova service in Pune for a stress-free travel experience. Our professional chauffeurs are courteous, experienced, and familiar with Pune’s routes, ensuring timely pickups and drop-offs. Ideal for business meetings, airport transfers, and special occasions requiring reliable and elegant transportation."
  },
  {
    "name": "Innova for Outstation Pune",
    "description": "Travel comfortably on long-distance trips with our Innova for Outstation service from Pune. Equipped with spacious seating and luggage capacity, these vehicles are perfect for family vacations, corporate tours, and weekend getaways. Enjoy competitive rates, experienced drivers, and flexible booking options tailored to your travel plans."
  },
  {
    "name": "Self Drive Innova Pune",
    "description": "Explore Pune and its surroundings on your own terms with our Self Drive Innova service. Enjoy the freedom of driving a premium SUV without the hassle of ownership. Our vehicles are regularly serviced and come with all necessary documentation, allowing you a safe and enjoyable driving experience."
  },
  {
    "name": "Best Innova Crysta Pune",
    "description": "We pride ourselves on offering the Best Innova Crysta rental service in Pune, with a focus on vehicle quality, customer service, and affordability. Our fleet is meticulously maintained, and our customer support is available 24/7 to assist you with bookings, queries, and special requests."
  },
  {
    "name": "AC Innova Pune Rental",
    "description": "Beat the heat with our AC Innova Rental service in Pune. All our Innova Crysta vehicles come equipped with efficient air conditioning systems, ensuring a cool and comfortable ride regardless of the weather. Perfect for summer travel, corporate clients, and family outings."
  },
  {
    "name": "Premium SUV Hire Pune",
    "description": "For those seeking luxury and performance, our Premium SUV Hire in Pune includes the Innova Crysta as a top choice. Enjoy spacious interiors, advanced safety features, and superior ride quality, driven by professional chauffeurs committed to providing an exceptional travel experience."
  },
  {
    "name": "Corporate Innova Pune",
    "description": "Our Corporate Innova service in Pune caters to business clients who require reliable and stylish transportation. Whether for airport transfers, client meetings, or corporate events, our Innova Crysta vehicles offer a professional atmosphere combined with comfort and punctuality."
  },
  {
    "name": "Affordable Innova Crysta Pune",
    "description": "Get the best value with our Affordable Innova Crysta rental in Pune, offering competitive rates without compromising on comfort or quality. Ideal for budget-conscious travelers, startups, and small businesses needing dependable SUV rentals."
  },
  {
    "name": "Monthly Innova Rental Pune",
    "description": "Plan your transportation with our Monthly Innova Rental service in Pune, perfect for long-term business needs or extended family trips. Benefit from flexible rental agreements, priority vehicle availability, and dedicated customer support throughout your rental period."
  },
  {
    "name": "Innova with Driver Pune",
    "description": "Book an Innova with Driver in Pune for a convenient and comfortable travel experience. Our drivers are professionally trained, punctual, and knowledgeable about local routes to ensure timely arrivals and smooth journeys for all occasions."
  },
  {
    "name": "Wedding Innova Pune",
    "description": "Make your special day memorable with our Wedding Innova service in Pune. Our pristine vehicles and professional chauffeurs provide elegant and reliable transportation for the bride, groom, and wedding party, ensuring a stylish and timely arrival at your wedding venues."
  },
  {
    "name": "Group Travel Innova Pune",
    "description": "Travel together comfortably with our Group Travel Innova service in Pune. Perfect for family outings, corporate retreats, and group tours, our spacious Innova Crysta SUVs accommodate up to 7 passengers, offering ample luggage space and a smooth, enjoyable ride."
  }
],
"tableData": [
  ["Innova Crysta Rental in Pune", "Hire Innova Crysta Pune"],
  ["Pune SUV Rental", "Chauffeur Driven Innova Pune"],
  ["Innova for Outstation Pune", "Self Drive Innova Pune"],
  ["Best Innova Crysta Pune", "AC Innova Pune Rental"],
  ["Premium SUV Hire Pune", "Corporate Innova Pune"],
  ["Affordable Innova Crysta Pune", "Monthly Innova Rental Pune"],
  ["Innova with Driver Pune", "Wedding Innova Pune"],
  ["Group Travel Innova Pune", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Premium Innova Crysta Rental Services in Pune",
    "WhyChoosedescription": "Aaryan Travels offers reliable and comfortable Innova Crysta rentals for all your travel needs in Pune."
  },
  {
    "WhyChooseheading": "Well-Maintained Innova Crysta Vehicles",
    "WhyChoosedescription": "Travel in clean, sanitized, and air-conditioned Innova Crysta cars for a luxurious and safe journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
    "WhyChoosedescription": "Our professional drivers are familiar with Pune’s routes to provide timely and smooth rides."
  },
  {
    "WhyChooseheading": "Flexible Rental Options to Suit Your Schedule",
    "WhyChoosedescription": "Choose hourly rentals, full-day bookings, or outstation trips with convenient pickup and drop services."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront pricing covering fuel, tolls, and driver allowances with complete transparency."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our support team is available round the clock to assist with your Innova Crysta rental bookings."
  },
  {
    "WhyChooseheading": "Ideal for Family Trips, Corporate Travel, and Group Outings",
    "WhyChoosedescription": "Perfect vehicle choice for comfortable travel with family, colleagues, or friends."
  },
  {
    "WhyChooseheading": "Safe and Reliable Service You Can Trust",
    "WhyChoosedescription": "Aaryan Travels ensures a hassle-free and secure rental experience with professional service."
  }
]



















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer Innova Crysta rental services in Pune?',
    answer: 'Yes, Aaryan Travels provides premium Innova Crysta rental services in Pune for comfortable and spacious travel.',
  },
  {
    question: 'How can I book an Innova Crysta rental in Pune with Aaryan Travels?',
    answer: 'You can book your Innova Crysta easily through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of trips can I use the Innova Crysta rental for in Pune?',
    answer: 'Our Innova Crysta rentals are suitable for local travel, outstation trips, corporate travel, and special occasions in Pune.',
  },
  {
    question: 'Are the Innova Crysta vehicles well-maintained and sanitized?',
    answer: 'Absolutely. All Innova Crysta vehicles are regularly serviced and sanitized to ensure passenger safety and comfort.',
  },
  {
    question: 'Can I hire Innova Crysta on an hourly or full-day basis in Pune?',
    answer: 'Yes, we offer flexible hourly and full-day rental packages for Innova Crysta in Pune.',
  },
  {
    question: 'Are experienced drivers provided with the Innova Crysta rental?',
    answer: 'Yes, our drivers are professionally trained, courteous, and familiar with Pune routes.',
  },
  {
    question: 'Is the Innova Crysta rental service available 24x7 in Pune?',
    answer: 'Yes, Aaryan Travels offers round-the-clock Innova Crysta rental services in Pune.',
  },
  {
    question: 'What payment methods are accepted for Innova Crysta rentals in Pune?',
    answer: 'We accept cash, digital wallets, UPI, and card payments for convenient transactions.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for Innova Crysta rental in Pune?',
    answer: 'Yes, you can specify your preferred pickup and drop-off points within Pune as per your travel plans.',
  },
  {
    question: 'Is booking an Innova Crysta rental with Aaryan Travels reliable and safe?',
    answer: 'Definitely. Aaryan Travels ensures timely, safe, and reliable Innova Crysta rental services with professional drivers.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Sharma',
    feedback: 'The Innova Crysta rental from Aaryan Travels in Pune was comfortable and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Kulkarni',
    feedback: 'Great experience with Aaryan Travels’ Innova Crysta rental service in Pune. Highly recommended!',
    rating: 5,
  },
];




















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta Rental in Pune",
  "image": "https://aaryantravels.com/assets/images/innova-crysta-pune.jpg", // replace with actual image URL
  "description": "Premium Innova Crysta rental service in Pune by Aaryan Travels. Choose from chauffeur-driven or self-drive options for outstation trips, corporate travel, weddings, and group tours. Affordable monthly rentals also available.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // example rating, update as needed
    "ratingCount": "3900", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/innova-crysta-rental-pune"
  }
};






  return (
    <div>

<Helmet>
  <title>Innova Crysta Rental in Pune | Premium SUV Hire | Aaryan Travels</title>
  <meta
    name="description"
    content="Premium Innova Crysta rental service in Pune by Aaryan Travels. Choose from chauffeur-driven or self-drive options for outstation trips, corporate travel, weddings, and group tours. Affordable monthly rentals also available."
  />
  <meta
    name="keywords"
    content="Innova Crysta Rental in Pune, Hire Innova Crysta Pune, Pune SUV Rental, Chauffeur Driven Innova Pune, Innova for Outstation Pune, Self Drive Innova Pune, Best Innova Crysta Pune, AC Innova Pune Rental, Premium SUV Hire Pune, Corporate Innova Pune, Affordable Innova Crysta Pune, Monthly Innova Rental Pune, Innova with Driver Pune, Wedding Innova Pune, Group Travel Innova Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/11.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystarentalinpune;